export const timedOut = () => {
  return JSON.parse(localStorage.getItem("timedOut") ?? "false");
};

export const setTimedOut = (timedOut: boolean) => {
  localStorage.setItem("timedOut", JSON.stringify(timedOut));
};